import {TemplateType} from "../../client/generated/graphql";
import i18n from "../../client/services/i18n";

export const getMailjetTemplateId = (templateType: TemplateType) => {
    switch (templateType) {
        case TemplateType.BookingConfirmation:
            // return EmailTemplates.BookingConfirmation;
            return "2046014";
            break;
        case TemplateType.BookingCancellation:
            // return EmailTemplates.BookingCancellation;
            return "1291189";
            break;
        case TemplateType.SettlementConfirmation:
            // return EmailTemplates.InvoiceSettlement;
            return "2123003";
            break;

        case TemplateType.WaitingListConfirmation:
            // return EmailTemplates.WaitingListConfirmation;
            return "2473686";
            break;

        default:
            // return EmailTemplates.Blank;
            return "2288419";
            break;
    }
};

export const renderTitle = (type: TemplateType | string | undefined) => {
    switch (type) {
        case "Warning":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.warning();
        case "BookingConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.bookingConfirmation();
        case "BookingConfirmationMollie":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.bookingConfirmationMollie();
        case "WaitingListConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.waitingListConfirmation();
        case "SettlementConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.invoice();
        case "Reminder":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.courseMemory();
        case "SettledBookingCancellation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.cancelInvoice();
        case "InterestListConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.interestListConfirmation();
        case "Transfer":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.transfer();
        case "DunningReminder":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningReminder();
        case "DunningLevel1":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningLevel1();
        case "DunningLevel2":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningLevel2();
        case "DunningLevel3":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningLevel3();
        case "Tarif595Receipt":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.tarif595Receipt();
        case "MolliePaymentFailed":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.molliePaymentFailed();
        case "MolliePaymentCanceled":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.molliePaymentCanceled();
        case "MolliePaymentExpired":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.molliePaymentExpired();
        case "NoTemplate":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.noTemplate();
        case "Invoice":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.invoice();
        case "InvoiceMonthly":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.invoiceMonthly();
        case "InvoiceMonthlyConsistent":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.invoiceMonthlyConsistent();
        case "InvoiceReversal":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.invoiceReversal();
        case "InvoiceReversalMonthly":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.invoiceReversalMonthly();
        case "InvoiceReversalMonthlyConsistent":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.invoiceReversalMonthlyConsistent();
        default:
            return type;
    }
};

export const renderTitleDescription = (type: TemplateType | string | undefined) => {
    switch (type) {
        case "InvoiceMonthly":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.monthlyDescription();
        case "InvoiceMonthlyConsistent":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.monthlyDescriptionConsistent();
        case "InvoiceReversalMonthly":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.monthlyDescription();
        case "InvoiceReversalMonthlyConsistent":
            return i18n.containers.templates.InvoiceTemplates.defaultTemplates.monthlyDescriptionConsistent();
        default:
            return type;
    }
};
